import { render, staticRenderFns } from "./ViFeesManagementHome.vue?vue&type=template&id=babc2afc"
import script from "./ViFeesManagementHome.vue?vue&type=script&lang=js"
export * from "./ViFeesManagementHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports